import { createStore, combineReducers, applyMiddleware, compose} from "redux";
import thunk from "redux-thunk";
import bookReducer from "./reducers/bookReducer";
import categoryReducer from "./reducers/categoryReducer";
import collectionReducer from "./reducers/collectionReducer";
import ebookReducer from "./reducers/ebookReducer";
import requestReducer from "./reducers/requestReducer";
import transactionReducer from "./reducers/transactionReducer";

import uiReducer from "./reducers/uiReducer";
import userReducer from "./reducers/userReducer";

const initialState = {};


const middleware = [thunk];

const reducers = combineReducers({
    ui: uiReducer,
    user: userReducer,
    book: bookReducer,
    collection: collectionReducer,
    category: categoryReducer,
    ebook: ebookReducer,
    request: requestReducer,
    transaction: transactionReducer
});
const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}):compose;
const enhancer = composeEnhancers(applyMiddleware(...middleware));
const store = createStore(reducers, initialState, enhancer);

export default store;